import { selectedAlertsConstants } from "../_constants";

export function selectedAlerts(state = { selected: [] }, { type, ids }) {
  switch (type) {
  case selectedAlertsConstants.SELECT: {
    return {
      selected: [...state.selected, ...ids]
    };
  }

  case selectedAlertsConstants.DESELECT: {
    const newList = [...state.selected];
    ids.forEach(id => {
      const alertIndex = newList.indexOf(id);
      if (alertIndex >= 0) {
        newList.splice(alertIndex, 1);
      }
    });
    return {
      selected: newList
    };
  }

  case selectedAlertsConstants.CLEAR: {
    return {
      selected: []
    };
  }

  default: {
    return state;
  }
  }
}



// WEBPACK FOOTER //
// ./src/_reducers/selectedAlerts.reducer.js